import { Box, Stack, Typography } from '@mui/material';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import {
  CREDIT_PRICE_TYPES,
  type AddCreditForm,
  CreditPriceType,
} from '../add-credit-form/add-credit-form-schema';
import { VyRadioCardWrapper } from '../../../../../../components/new-design/inputs/VyRadioCard/VyRadioCardWrapper.tsx';

export const PriceTypeRadioCards: React.FC = () => {
  const { watch, setValue } = useFormContext<AddCreditForm>();
  const priceType = watch('priceType');

  const handleClick = (priceType: CreditPriceType) => {
    setValue('priceType', priceType, { shouldDirty: true, shouldValidate: true });
  };

  return (
    <Stack direction="row" spacing={2}>
      <Box data-vy="add-credit-drawer-price-type-one-time-card" sx={{ flex: 1, display: 'flex' }}>
        <VyRadioCardWrapper
          onClick={() => handleClick(CREDIT_PRICE_TYPES.OneTime)}
          isSelected={priceType === CREDIT_PRICE_TYPES.OneTime}
          renderContent={(isSelected) => (
            <Typography
              sx={{ fontSize: '14px', textAlign: 'center', color: isSelected ? '#020F20' : '#5F6978' }}
            >
              One-Time
            </Typography>
          )}
        />
      </Box>
      <Box data-vy="add-credit-drawer-price-type-recurring-card" sx={{ flex: 1, display: 'flex' }}>
        <VyRadioCardWrapper
          onClick={() => handleClick(CREDIT_PRICE_TYPES.Recurring)}
          isSelected={priceType === CREDIT_PRICE_TYPES.Recurring}
          renderContent={(isSelected) => (
            <Typography
              sx={{ fontSize: '14px', textAlign: 'center', color: isSelected ? '#020F20' : '#5F6978' }}
            >
              Recurring
            </Typography>
          )}
        />
      </Box>
    </Stack>
  );
};
